import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase";
import { firestorePlugin } from "vuefire";
import "./registerServiceWorker";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);

Vue.config.productionTip = false;

let app;
if (!app) {
  app = new Vue({
    router,
    render: (h) => h(App),
    created() {
    },
  }).$mount("#app");
}